<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-power-plug`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 4a1 1 0 011 1v3h20V5a1 1 0 011-1h2a1 1 0 011 1v3h7a1 1 0 011 1v2a1 1 0 01-1 1h-1v9.143c0 9.188-7.159 16.68-16.084 16.854L27.6 38H26v5a1 1 0 01-1 1h-2a1 1 0 01-1-1v-5h-1.6c-8.966 0-16.23-7.386-16.397-16.534L4 21.143V12H3a1 1 0 01-1-1V9a1 1 0 011-1h7V5a1 1 0 011-1h2zm27 8H8v9.143c0 7.01 5.403 12.688 12.1 12.853l.3.004h7.2C34.434 34 40 28.257 40 21.143V12zm-14.237 2c.438 0 .793.356.793.796v5.825l3.772.584a.798.798 0 01.49 1.295l-7.627 9.213a.792.792 0 01-1.403-.509v-6.136l-4.143-.792a.798.798 0 01-.436-1.32l7.97-8.699a.792.792 0 01.584-.257z"/></svg>
</template>
<script>

export default {
  name: 'IconPowerPlug',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
